import { render, staticRenderFns } from "./MainCom.vue?vue&type=template&id=b816406c&scoped=true"
import script from "./MainCom.vue?vue&type=script&lang=js"
export * from "./MainCom.vue?vue&type=script&lang=js"
import style0 from "./MainCom.vue?vue&type=style&index=0&id=b816406c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b816406c",
  null
  
)

export default component.exports